<template>
    <div class="form-row h-100">
        <span id="location-label" ref="location_label" class="col-md-6 text-center text-md-right my-auto">{{text.where_do_you_live}}</span>
        <div class="form-group multiselect-holder col-md-6 text-center">
            <multiselect
                    v-model="place"
                    id="ajax"
                    label="title"
                    track-by="title"
                    :placeholder="word.type_to_search"
                    :options="places"
                    :multiple="false"
                    :searchable="true"
                    :loading="placesSpinner"
                    :internal-search="true"
                    :max-height="600"
                    :show-no-results="true"
                    :hide-selected="false"
                    @search-change="findPlaces"
            >
                <span slot="noResult">{{text.no_elements_found}}</span>
                <span slot="noOptions">{{text.enter_something_for_suggestion}}</span>
            </multiselect>
            <input id="place_id" type="hidden" v-model="placeId" name="place_id">
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";

    export default {
        components: {
            Multiselect,
        },
        data() {
            return {
                loading: false,
                places: [],
                word: window.word,
                text: window.text,
                placesSpinner: false,
                place: null,
                placeId: null,
                place_detail: null,
                findPlacesTimeOut: null,
                findPlaceDetailTimeOut: null,
                numOfChangeQuery: 0,
            }
        },
        methods: {
            findPlaces(query) {
                this.numOfChangeQuery++;
                let self = this;
                self.placesSpinner = true;
                if (self.findPlacesTimeOut) {
                    clearTimeout(self.findPlacesTimeOut);
                }
                self.findPlacesTimeOut = setTimeout(function () {
                    axios({
                        method: "get",
                        url: "/places/search/" + query
                    })
                        .then(res => {
                            self.placesSpinner = false;
                            if (res.data.places != undefined) {
                                self.places = res.data.places;
                            }
                        })
                        .catch(() => self.placesSpinner = false);
                }, 1000);
            },
            onPlaceChanged(place) {
                console.log(place)
            }
        },
        watch: {
            place: {
                handler() {
                    if (this.place && this.place !== null)  this.placeId = this.place.id;
                }
            }
        },
        mounted() {
            // document.getElementsByClassName('multiselect')[0].style.width = window.getComputedStyle(document.getElementsByClassName('about-me')[0].getElementsByTagName('div')[0].getElementsByTagName('input')[0]).width;
            this.$refs.location_label.style = window.getComputedStyle(document.getElementsByClassName('about-me')[0].getElementsByTagName('div')[0].getElementsByTagName('span')[0]);
        }
    }
</script>

<style scoped>
    #location-label {
        font-size: 18px;
        padding-right: 10px;
        white-space: nowrap;
        font-weight: 600;
    }

    .multiselect-holder{
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

</style>
